import React, { useContext } from 'react'
import { LocalizationContext } from '../../shared/contexts'
import { formatTenantDateTime } from '../../../utils/formatTenantDateTime'
import { Box, Chip } from '@mui/material'

import { TIME_SOURCE } from '../../../utils/timeSource'

interface DisposalNoticeProps {
  markedForDisposal: boolean
  disposalReason: string | null
  disposedAt: string | null
  variant?: 'badge' | 'banner'
}

const DisposalNotice = ({
  markedForDisposal,
  disposalReason,
  disposedAt,
  variant = 'banner'
}: DisposalNoticeProps) => {
  const localization = useContext(LocalizationContext)
  const formatDateTime = (value: string | null) => formatTenantDateTime(value, localization)

  if (!markedForDisposal) return null

  const reason = disposalReason ? disposalReason.replace(/_/g, ' ') : 'unknown reason'

  if (variant === 'badge') {
    return <Chip className='disposal-badge' label={`For disposal: ${reason}`} size='small' />
  }

  return (
    <Box className='disposal-notice'>
      <i className='fa fa-exclamation-triangle' />
      <span><strong>Marked for disposal</strong> · Reason: {reason}</span>
      {disposedAt && <span title={TIME_SOURCE.app}> · Disposed at: {formatDateTime(disposedAt)}</span>}
    </Box>
  )
}

export default DisposalNotice
